import React, { useState } from 'react'
import { css, StyleSheet } from 'aphrodite'
import constants from 'utils/constants'

interface CliniquesSliderNavDotProps {
  index: number,
  isActive: boolean,
  goTo: (i) => void,
}
export default ({ index, isActive, goTo }: CliniquesSliderNavDotProps) => {
  const [isHover, setIsHover] = useState(false)
  const handleOver = () => setIsHover(true)
  const handleOut = () => setIsHover(false)
  const dotColor = isHover ? constants.colors.darkGreen : constants.colors.green
  const dotSize = isHover || isActive ? 14 : 10
  const dotOpacity = isActive ? 1 : 0.7
  const styles = StyleSheet.create({
    dot: {
      backgroundColor: dotColor,
      height: dotSize,
      width: dotSize,
      opacity: dotOpacity,
      borderRadius: 27,
      transition: 'all 0.1s ease-in',
      ':before': {
        color: 'transparent',
      },
      color: 'transparent',
    },
    item: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 15,
      minWidth: 30,
    },
  })
  return (
    <li className={css(styles.item)} role="presentation">
      <button
        onMouseOver={handleOver}
        onFocus={handleOver}
        onMouseOut={handleOut}
        onBlur={handleOut}
        className={css(styles.dot)}
        onClick={() => goTo(index)}
        tabIndex={index}
        aria-selected="true"
        type="button"
        role="tab"
      >
        {index + 1}
      </button>
    </li>
  )
}
